import React, { useEffect, useState, lazy, createElement } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { XIcon } from 'lucide-react';
const LOGO_URL = 'https://uploadthingy.s3.us-west-1.amazonaws.com/2KuE4GiXagr4eVmupSGvce/fluid-form-logo.png';
const ChatBubble = () => {
  const [isOpen, setIsOpen] = useState(false);
  useEffect(() => {
    const existingScript = document.querySelector('script[src="https://app.fluid-form.ai/fluid-navigate.js"]');
    if (!existingScript) {
      const script = document.createElement('script');
      script.src = 'https://app.fluid-form.ai/fluid-navigate.js';
      script.async = true;
      document.body.appendChild(script);
    }
  }, []);
  return <div className="fixed bottom-5 right-5 z-[9999]" data-id="element-59">
      {/* Chat Panel */}
      <AnimatePresence data-id="element-60">
        {isOpen && <motion.div initial={{
        opacity: 0,
        scale: 0.9,
        y: 20
      }} animate={{
        opacity: 1,
        scale: 1,
        y: 0
      }} exit={{
        opacity: 0,
        scale: 0.9,
        y: 20
      }} transition={{
        type: 'spring',
        stiffness: 300,
        damping: 25
      }} className="absolute bottom-16 right-0 w-[380px] max-w-[calc(100vw-40px)] bg-white rounded-2xl shadow-2xl border border-gray-200 overflow-hidden" style={{
        height: '560px'
      }} data-id="element-61">
            {/* Header */}
            <div className="flex items-center justify-between px-4 py-3 bg-orange-500 text-white" data-id="element-62">
              <div className="flex items-center gap-2.5" data-id="element-63">
                <div className="w-8 h-8 bg-white rounded-lg flex items-center justify-center p-1" data-id="element-64">
                  <img src={LOGO_URL} alt="FluidForm" className="h-5 w-auto object-contain" loading="lazy" width="20" height="20" data-id="element-65" />
                </div>
                <div data-id="element-66">
                  <p className="text-sm font-semibold leading-tight" data-id="element-67">
                    Contact Us
                  </p>
                </div>
              </div>
              <button onClick={() => setIsOpen(false)} className="w-7 h-7 rounded-full bg-white/20 hover:bg-white/30 flex items-center justify-center transition-colors" aria-label="Close chat" data-id="element-68">
                <XIcon size={14} data-id="element-69" />
              </button>
            </div>

            {/* Iframe */}
            <iframe src="https://app.fluid-form.ai/ff/org_370FLDDfGS3A3yaESUAAv8eTIQ5/lead-gen-form?sig=org_370FLDDfGS3A3yaESUAAv8eTIQ5-lead-gen-form-96c677b04ba10244&mode=headless&chatPath=chat-router" className="w-full border-0 block" style={{
          background: 'transparent',
          height: 'calc(100% - 52px)',
          overflow: 'hidden'
        }} title="Contact Us Form" frameBorder="0" scrolling="no" allowTransparency={true} loading="lazy" data-id="element-70" />
          </motion.div>}
      </AnimatePresence>

      {/* Floating Button */}
      <motion.button onClick={() => setIsOpen(!isOpen)} className={`shadow-lg hover:shadow-xl transition-all overflow-hidden ${isOpen ? 'w-14 h-14 rounded-full bg-orange-500 text-white hover:bg-orange-600 flex items-center justify-center' : 'h-12 rounded-full bg-orange-500 text-white hover:bg-orange-600 flex items-center gap-2.5 pl-3.5 pr-5'}`} whileTap={{
      scale: 0.95
    }} aria-label={isOpen ? 'Close chat' : 'Open chat'} data-id="element-71">
        <AnimatePresence mode="wait" data-id="element-72">
          {isOpen ? <motion.div key="close" initial={{
          rotate: -90,
          opacity: 0
        }} animate={{
          rotate: 0,
          opacity: 1
        }} exit={{
          rotate: 90,
          opacity: 0
        }} transition={{
          duration: 0.15
        }} data-id="element-73">
              <XIcon size={24} data-id="element-74" />
            </motion.div> : <motion.div key="open" initial={{
          opacity: 0,
          x: 10
        }} animate={{
          opacity: 1,
          x: 0
        }} exit={{
          opacity: 0,
          x: 10
        }} transition={{
          duration: 0.2
        }} className="flex items-center gap-2.5" data-id="element-75">
              <img src={LOGO_URL} alt="FluidForm" className="h-6 w-auto object-contain brightness-0 invert" loading="lazy" width="24" height="24" data-id="element-76" />
              <span className="text-sm font-semibold whitespace-nowrap" data-id="element-77">
                Contact Us
              </span>
            </motion.div>}
        </AnimatePresence>
      </motion.button>
    </div>;
};
export default ChatBubble;